import { render, staticRenderFns } from "./TabService.vue?vue&type=template&id=3231239c"
import script from "./TabService.vue?vue&type=script&lang=js"
export * from "./TabService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports